import { Compartment } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { type RefObject } from 'react';

/**
 * Configures the readonly functionality on the editor.
 * @param lineWrap - flag pointing to whether lineWrap is enabled or not
 * @param viewRef - Ref object for the editor
 * @param lineWrappingCompartment -
 */
export const configureLineWrap = (
  lineWrap: boolean,
  viewRef: RefObject<EditorView>,
  lineWrappingCompartment: Compartment,
): void => {
  const editorView = viewRef.current;
  editorView.dispatch({
    effects: lineWrappingCompartment.reconfigure(
      lineWrap ? EditorView.lineWrapping : [],
    ),
  });
};
